/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AssignDevice
 */
export interface AssignDevice {
    /**
     * 
     * @type {string}
     * @memberof AssignDevice
     */
    'platformId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignDevice
     */
    'platform': AssignDevicePlatformEnum;
}

export const AssignDevicePlatformEnum = {
    C8y: 'c8y',
    Temetra: 'temetra',
    Onconnect: 'onconnect'
} as const;

export type AssignDevicePlatformEnum = typeof AssignDevicePlatformEnum[keyof typeof AssignDevicePlatformEnum];


